import axios from 'axios';

import { FetchStatus } from '@powdr/constants';
import { getNodeApiDomain } from '@powdr/utils';

import { PLACES_PENDING, PLACES_SUCCESS, PLACES_ERROR } from '../types';

export const getPlaces = () => async (dispatch, getState) => {
  const placesStatus = getState().places.status;

  // If more than one component calls the same feed make sure we only make one request
  if (placesStatus !== FetchStatus.LOADING && placesStatus !== FetchStatus.PENDING) {
    try {
      dispatch({
        type: PLACES_PENDING,
        payload: [],
      });
      const res = await axios.get(`${getNodeApiDomain()}/dor/drupal/places`);
      dispatch({
        type: PLACES_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: PLACES_ERROR,
        payload: error,
      });
    }
  }
};
